import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CommonService } from 'src/app/shared/utils/common.service';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { moduloGaritas } from '../diccionarios/balanzaModulo.js';
import { IReqUsuarioBasculaGarita } from '../modelos/IReqUsuarioBasculaGarita.js';
import { IUsuarioBasculaGarita } from '../modelos/IUsuarioBasculaGarita.js';

@Injectable({
  providedIn: 'root'
})
export class UsuarioBasculaGaritaService {

  private diccionarioModulo: any;
  private url: string;

  constructor(private _util: UtilsService, private _commom: CommonService) {
    this.diccionarioModulo = moduloGaritas;
    this.url = this._util.getUrlBascula();
  }

  obtener(): Observable<IUsuarioBasculaGarita[]> {
    return this._commom.peticionGetConHeader(
      this.url + this.diccionarioModulo.url.mantUsuarioBasculaGarita.obtenerTodo
    );
  }

  crear(request: IReqUsuarioBasculaGarita) {
    return this._commom.peticionPostConHeader(
      this.url + this.diccionarioModulo.url.mantUsuarioBasculaGarita.crear,
      request
    );
  }

  editar(request: IReqUsuarioBasculaGarita) {
    return this._commom.peticionPutConHeader(
      this.url + this.diccionarioModulo.url.mantUsuarioBasculaGarita.actualizar,
      request
    );
  }

  eliminar(id: number) {
    return this._commom.peticionDeleteConHeader(
      this.url + this.diccionarioModulo.url.mantUsuarioBasculaGarita.eliminar + id
    );
  }

  obtenerPorUsuario(username: string, tipo: string): Observable<IReqUsuarioBasculaGarita> {
    return this._commom.peticionGetConHeader(
      this.url + this.diccionarioModulo.url.mantUsuarioBasculaGarita.buscarporUsuario + username + '&tipo=' + tipo
    );
  }

  obtenerUsuario(username: string): Observable<any> {
    return this._commom.peticionGetConHeader(
      this.url + this.diccionarioModulo.url.mantUsuarioBasculaGarita.buscarporUsuario + username
    );
  }

  obtenerPorId(id: string): Observable<any> {
    return this._commom.peticionGetConHeader(
      this.url + this.diccionarioModulo.url.mantUsuarioBasculaGarita.buscarporId + id
    );
  }

}
